<template>
  <el-dialog
:visible="dialogVisible"
width="500px"
:before-close="close"
:close-on-click-modal="false"
:title="title"
    class="customDialogForm">
    <el-form ref="appform" :rules="rules" :model="app">
      <el-form-item prop="name" label="名称" :label-width="formLabelWidth">
        <el-input v-model="app.name" placeholder="选输入应用名称" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item prop="appClassificationID" label="分类" :label-width="formLabelWidth" style="margin-bottom: 0">
        <el-select v-model="app.appClassificationID" placeholder="选择应用分类" style="width: 100%">
          <template v-for="item in classes">
            <el-option
              v-if="item.parentAppClassificationID"
              :key="item.appClassificationID"
              :label="item.appClassificationName"
              :value="item.appClassificationID"
            ></el-option>
          </template>
        </el-select>
        <span class="inputdesc">为了适应前台展示，应用只能属于二级分类</span>
      </el-form-item>
      <el-form-item prop="desc" label="简介" :label-width="formLabelWidth">
        <el-input v-model="app.desc" type="textarea" autocomplete="off"></el-input>
      </el-form-item>
      <el-row>
        <el-col class="appsFrom">
          <el-form-item
label="应用Logo"
ref="uploadpic"
class="el-form-item-cen"
prop="logo"
            style="margin-left: 10px; display: flex;">
            <el-upload
class="avatar-uploader"
:action="uploadConfig.api"
:with-credentials="true"
              :headers="uploadConfig.headers"
:show-file-list="false"
:on-success="handleAvatarSuccess"
              :on-error="handleAvatarError"
:before-upload="beforeAvatarUpload">
              <img v-if="app.logo" :src="app.logo" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              <i v-if="app.logo" class="el-icon-delete" @click.stop="() => handleRemove()"></i>
            </el-upload>
            <span style="color: #999999; font-size: 12px">
              建议上传 100*100 比例的Logo
            </span>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" @click="submit" :loading="Loading">
        确 定
      </el-button>
    </div>
  </el-dialog>
</template>
<script>
import { getStoreAvailableTags } from '@/api/appStore';
import { getSelfAppList } from '@/api/user';
import { mapState } from 'vuex';
import { errorHandle } from '../../../../utils/error';
import { getToken } from '@/utils/auth';
export default {
  name: 'CreateApp',
  props: {
    marketID: String,
    dialogVisible: Boolean,
    onClose: Function,
    onSuccess: Function
  },
  data() {
    var baseDomain = process.env.BASE_API;
    if (baseDomain == '/') {
      baseDomain = window.location.origin;
    }
    return {
      uploadConfig: {
        api: `${baseDomain}/app-server/uploads/picture`,
        headers: {
          Authorization: getToken()
        }
      },
      classes: [],
      existTags: [],
      appPublishTypes: [
        {
          value: 'public',
          label: '免费公开'
        },
        {
          value: 'integral',
          label: '金额销售'
        },
        {
          value: 'private',
          label: '私有'
        },
        {
          value: 'show',
          label: '展览'
        }
      ],
      // appTemplateType: [
      //   {
      //     value: 'helm',
      //     label: 'Helm Chart'
      //   },
      //   {
      //     value: 'rainbond',
      //     label: 'Rainbond App Model'
      //   },
      //   {
      //     value: 'file',
      //     label: '软件包'
      //   },
      // ],
      rules: {
        name: [
          { required: true, message: '请输入应用名称', trigger: 'blur' },
          {
            min: 2,
            max: 255,
            message: '分类名称必须大于1个字符',
            trigger: 'blur'
          },
          { max: 30, message: '应用名称最大不超过30字符', trigger: 'blur' }
        ],
        publishType: [
          { required: true, message: '请选择应用类型', trigger: 'blur' }
        ],
        templateType: [
          { required: true, message: '请选择应用模版类型', trigger: 'blur' }
        ],
        appClassificationID: [
          { required: true, message: '请选择应用分类', trigger: 'change' }
        ],
        desc: [{ max: 255, message: '最大不超过255个字符', trigger: 'blur' }, { required: true, message: '请填写应用简介', trigger: 'blur' }]
      },
      app: {
        appClassificationID: '',
        name: '',
        desc: '',
        tags: [],
        publishType: '',
        marketID: '',
        // templateType: 'rainbond',
        logo: ''
      },
      title: '新增应用',
      formLabelWidth: '80px',
      Loading: false
    };
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo
    }),
    myorgs() {
      return this.$store.state.user.userOrgs;
    }
  },
  created() {
    this.fetchStoreAppClassList();
    this.fetchStoreAppTags();
  },

  methods: {
    handleAvatarSuccess(res, file) {
      this.app.logo = res.FileURL;
    },
    handleAvatarError(re) {
      if (re.code == 10024) {
        this.$message.warning(
          '上传图片类型不支持，请上传以.png .jpg .jpeg 结尾的图片'
        );
        return;
      }
      this.$message.warning('上传失败!');
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg';
      const isPng = file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG && !isPng) {
        this.$message.warning('上传Logo图片只能是JPG、PNG格式!');
      }
      if (!isLt2M) {
        this.$message.warning('上传头像图片大小不能超过 2MB!');
      }
      return (isJPG || isPng) && isLt2M;
    },
    handleRemove() {
      this.$confirm('是否删除logo', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.app.logo = '';
      });
    },
    fetchStoreAppClassList() {
      this.Loading = true;
      this.$store
        .dispatch('GetStoreAppClassificationList', {
          marketID: this.marketID,
          disableTree: true
        })
        .then((res) => {
          this.classes = Array.isArray(res)
            ? res
            : Array.isArray(res && res.list)
              ? res.list
              : [];
          this.Loading = false;
        })
        .catch((err) => {
          errorHandle(err);
          this.Loading = false;
        });
    },
    fetchStoreAppTags() {
      getStoreAvailableTags({
        marketID: this.marketID,
        size: -1
      })
        .then((res) => {
          if (res && res.tags) {
            const tags = [];
            res.tags.map((item) => {
              tags.push(item.name);
            });
            this.existTags = tags;
          }
        })
        .catch((err) => {
          errorHandle(err);
          this.Loading = false;
        });
    },
    submit() {
      this.Loading = true;
      this.$refs.appform.validate((valid) => {
        if (valid) {
          this.app.marketID = this.marketID;
          this.app.userID = this.userInfo.userID;
          this.$store
            .dispatch('CreateStoreApp', this.app)
            .then((res) => {
              getSelfAppList({
                marketID: res.marketID,
                userID: res.publishUser,
                page: 1,
                pageSize: 10
              }).then((res) => { });
              this.$message.success('应用添加成功,请完善应用信息，并上传应用版本。');
              this.onSuccess && this.onSuccess();
              this.close();
              this.Loading = false;
              this.$router.push({
                name: 'StoreTemplateManageDetails',
                params: { appID: res.appKeyID, tabMode: 'detail' }
              });
            })
            .catch((res) => {
              let msg = res && res.msg;
              if (res.code == 400) {
                msg = '参数错误';
              }
              this.$message({
                message: msg,
                type: 'warning'
              });
              this.Loading = false;
            });
        } else {
          this.Loading = false;
        }
      });
    },
    close() {
      this.$refs.appform.resetFields();
      this.onClose && this.onClose();
    }
  }
};
</script>
<style>
.inputdesc {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.45);
  transition: color 0.3s cubic-bezier(0.215, 0.61, 0.355, 1);
}
</style>



// WEBPACK FOOTER //
// src/views/storeManage/appManage/components/createApp.vue